import sistemaBNCCService from "./SistemaBNCCService";
import alunosService from "./AlunosService";
import anosService from "./AnosService";
import authService from "./AuthService";
import caixasService from "./CaixasService";
import franquiasService from "./FranquiasService";
import matriculasService from "./MatriculasService";
import formasDePagamentoService from "./FormasDePagamentoService";
import parcelasService from "./ParcelasService";
import turmasService from "./TurmasService";
import turnosService from "./TurnosService";
import seriesService from "./SeriesService";
import cursosService from "./CursosService";
import cepService from "./CepService";
import disciplinasService from "./DisciplinasService";
import professoresService from "./ProfessoresService";
import usuariosService from "./UsuariosService";
import inepService from "./InepService";
import gestoesDeAulasService from "./GestoesDeAulasService";
import aulasService from "./AulasService";
import notasService from "./NotasService";
import relatoriosService from "./RelatoriosService";
import tiposDeEnsinosService from "./TiposDeEnsinosService";
import planosBimestraisService from "./PlanosBimestraisService";
import rolesService from "./RolesService";
import avisosService from "./AvisosService";
import imageService from "./ImageService";
import agendasService from "./AgendaService";
import notifiqService from "./NotifiqService";
import responsavelAlunoService from "./ResponsavelAlunoService";
import horariosService from "./HorariosService";
import planosAnuaisService from "./PlanosAnuaisService";
import webInfo from "./WebInfo";
import informativosService from "./InformativosService";
import gestoesDeEletivosService from "./GestoesDeEletivosService";
import aulasEletivosService from "./AulasEletivosService";
import ementasEletivasService from "./EmentasEletivasService";
import gestoesDeAulasAEEService from "./GestoesDeAulasAEEService";
import educacaoInclusivaService from "./EducacaoInclusivaService";

const $services = {
  alunosService,
  anosService,
  authService,
  caixasService,
  franquiasService,
  matriculasService,
  formasDePagamentoService,
  parcelasService,
  turmasService,
  turnosService,
  seriesService,
  cursosService,
  cepService,
  disciplinasService,
  professoresService,
  usuariosService,
  inepService,
  gestoesDeAulasService,
  aulasService,
  notasService,
  relatoriosService,
  sistemaBNCCService,
  tiposDeEnsinosService,
  planosBimestraisService,
  rolesService,
  avisosService,
  imageService,
  agendasService,
  notifiqService,
  responsavelAlunoService,
  horariosService,
  planosAnuaisService,
  webInfo,
  informativosService,
  gestoesDeEletivosService,
  aulasEletivosService,
  ementasEletivasService,
  gestoesDeAulasAEEService,
  educacaoInclusivaService,
};

export default $services;
